routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider']

// config file
import GlobalConfig from '../../../../../../globals/globalConfig.json'

export default function routes ($stateProvider, $urlRouterProvider, $locationProvider) {
  $locationProvider.html5Mode(true)
  $stateProvider
  .state('workplan.reviewConsolidation', {
    abstract: false,
    url: '/reviewConsolidation/teacher/:teacherId?name/workplan/:workplanId',
    template: '<activities-review></activities-review>',
    module: GlobalConfig.modules.consolidation,
    data: {
      displayName: 'Consolidación del cuerpo profesoral',
      title: 'Consolidación del cuerpo profesoral',
      order: 5,
      siblings: [
        {
          name: 'fullscreen.workPlanReview',
          order: 0
        },
        {
          name: 'workplan.reviewTeaching',
          order: 1,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.reviewAcademicManagement',
          order: 4,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.reviewInvestigation',
          order: 2,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.reviewExtension',
          order: 3,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.summaryReview',
          order: 6,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        }
      ]
    },
    params: {
      stage: 'review',
      roleId: GlobalConfig.userRolesIds.reviewer,
      inHistory: false
    }
  })
  .state('workplan.approvalConsolidation', {
    abstract: false,
    url: '/approvalConsolidation/teacher/:teacherId?name/workplan/:workplanId',
    template: '<activities-review></activities-review>',
    module: GlobalConfig.modules.consolidation,
    data: {
      displayName: 'Consolidación del cuerpo profesoral',
      title: 'Consolidación del cuerpo profesoral',
      order: 5,
      siblings: [
        {
          name: 'fullscreen.workPlanApproval',
          order: 0
        },
        {
          name: 'workplan.approvalTeaching',
          order: 1,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.approvalAcademicManagement',
          order: 4,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.approvalInvestigation',
          order: 2,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.approvalExtension',
          order: 3,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.summaryApproval',
          order: 6,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        }
      ]
    },
    params: {
      stage: 'approval',
      roleId: GlobalConfig.userRolesIds.approver,
      inHistory: false
    }
  })
  .state('workplan.executionConsolidation', {
    abstract: false,
    url: '/executionConsolidation',
    template: '<activities-review></activities-review>',
    module: GlobalConfig.modules.consolidation,
    data: {
      displayName: 'Consolidación del cuerpo profesoral',
      title: 'Consolidación del cuerpo profesoral',
      order: 5,
      siblings: [
        {
          name: 'fullscreen.workPlanExecution',
          order: 0
        },
        {
          name: 'workplan.executionTeaching',
          order: 1
        },
        {
          name: 'workplan.executionAcademicManagement',
          order: 4
        },
        {
          name: 'workplan.executionInvestigation',
          order: 2
        },
        {
          name: 'workplan.executionExtension',
          order: 3
        },
        {
          name: 'workplan.executionHistory',
          order: 6
        }
      ]
    },
    params: {
      stage: 'execution',
      roleId: GlobalConfig.userRolesIds.teacher,
      inHistory: false
    }
  })
  .state('workplan.reviewExecutionConsolidation', {
    abstract: false,
    url: '/reviewExecutionConsolidation/teacher/:teacherId?name/workplan/:workplanId',
    template: '<activities-review></activities-review>',
    module: GlobalConfig.modules.consolidation,
    data: {
      displayName: 'Consolidación del cuerpo profesoral',
      title: 'Consolidación del cuerpo profesoral',
      order: 5,
      siblings: [
        {
          name: 'fullscreen.workPlanReviewExecution',
          order: 0
        },
        {
          name: 'workplan.reviewExecutionTeaching',
          order: 1,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.reviewExecutionAcademicManagement',
          order: 4,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.reviewExecutionInvestigation',
          order: 2,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.reviewExecutionExtension',
          order: 3,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.summaryReviewExecution',
          order: 6,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        }
      ]
    },
    params: {
      stage: 'reviewExecution',
      roleId: GlobalConfig.userRolesIds.reviewer,
      inHistory: false
    }
  })
  .state('workplan.evaluationConsolidation', {
    abstract: false,
    url: '/evaluationConsolidation/teacher/:teacherId?name/workplan/:workplanId',
    template: '<activities-review></activities-review>',
    module: GlobalConfig.modules.consolidation,
    data: {
      displayName: 'Consolidación del cuerpo profesoral',
      title: 'Consolidación del cuerpo profesoral',
      order: 5,
      siblings: [
        {
          name: 'fullscreen.workPlanEvaluation',
          order: 0
        },
        {
          name: 'workplan.evaluationTeaching',
          order: 1,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.evaluationAcademicManagement',
          order: 4,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.evaluationInvestigation',
          order: 2,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.evaluationExtension',
          order: 3,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.summaryEvaluation',
          order: 6,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        }
      ]
    },
    params: {
      stage: 'evaluation',
      roleId: GlobalConfig.userRolesIds.approver,
      inHistory: false
    }
  })
}



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/partials/review/routes/consolidation.route.js